<template>
  <app-widget 
    :title="$t('device.locations.filter')">
    <v-form slot="widget-content">
      <v-row>
        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          
          <v-dialog
            ref="dialogStartDate"
            v-model="showModalStartDate"
            width="300px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                :label="$t('device.locations.startDate')"
                prepend-icon="event"
                autocomplete="off"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="startDate"  
              :allowed-dates="allowedMaxDate"
            >
              <v-spacer/>
              <v-btn 
                text 
                color="primary"
                @click="resetStartDate">
                {{$t('common.form.clear')}}
              </v-btn>
              <v-btn 
                text 
                color="primary"
                @click="onDateFieldChange">
                {{$t('common.form.ok')}}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          
          <v-dialog
            ref="dialogEndDate"
            v-model="showModalEndDate"
            width="300px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                :label="$t('device.locations.endDate')"
                prepend-icon="event"
                autocomplete="off"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="endDate"
              :allowed-dates="allowedMinDate"  
            >
              <v-spacer/>
              <v-btn 
                text 
                color="primary" 
                @click="resetEndDate">
                {{$t('common.form.clear')}}
              </v-btn>
              <v-btn 
                text 
                color="primary"
                @click="onDateFieldChange">
                {{$t('common.form.ok')}}
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col 
          xl="6"
          lg="6"
          md="6"
          sm="6"
          cols="12">
          
          <v-select
            data-cy="selectMoveDropDown"
            v-model="selectedMoveId"
            :clearable="true"
            :items="movesSelectItems"
            :label="$t('common.moves')"
            @change="onMoveUpdated"
            />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" justify="end" align="end">
          <v-btn @click="resetFilter" color="default">
            <v-icon small>
              refresh
            </v-icon>
            {{ $t('common.actions.reset') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/widgets/AppWidget';
import { API_DATE_FORMAT } from '@/constants/date';
import dayjs from 'dayjs';

export default {
  name: 'DeviceDetailFilter',
  props: {
    moves: Array,
    moveId: String
  },
  computed: {
    movesSelectItems() {
      const items = [];

      if(!this.moves) {
        return items;
      }

      this.moves.forEach(move => {
        items.push({
          text: move.name,
          value: move.moveId
        })
      })

      return items;
    }
  },
  data: () => ({
    showModalStartDate: false,
    showModalEndDate: false,
    selectedMoveId: null,
    startDate: dayjs().subtract(7, 'day').format(API_DATE_FORMAT),
    endDate: null
  }),
  mounted() {
    if(this.moveId) {
      this.selectedMoveId = this.moveId;
    }
  },
  methods: {
    onDateFieldChange() {
      this.showModalStartDate = false;
      this.showModalEndDate = false;
      this.onFilterUpdated();
    },
    resetFilter () {
      this.startDate = dayjs().subtract(7, 'day').format(API_DATE_FORMAT);
      this.endDate = null;
      this.selectedMoveId = null;

      this.$emit('onFilterChange', {
        locationsFromDate: this.startDate,
        locationsToDate: null,
        moveId: null
      })
    },
    resetStartDate () {
      this.startDate = null;
      this.showModalStartDate = false;

      this.$emit('onFilterChange', {
        locationsFromDate: this.startDate,
        locationsToDate: this.endDate,
        moveId: this.selectedMoveId
      })
    },
    resetEndDate () {
      this.endDate = null;
      this.showModalEndDate = false;

      this.$emit('onFilterChange', {
        locationsFromDate: this.startDate,
        locationsToDate: this.endDate,
        moveId: this.selectedMoveId
      })
    },
    onFilterUpdated () {
      this.$emit('onFilterChange', {
        locationsFromDate: this.startDate,
        locationsToDate: this.endDate,
        moveId: this.selectedMoveId
      })
    },
    onMoveUpdated () {
      this.startDate = null;
      this.endDate = null;

      this.$emit('onFilterChange', {
        locationsFromDate: this.startDate,
        locationsToDate: this.endDate,
        moveId: this.selectedMoveId
      })
    },
    allowedMaxDate(val) {
      const currentDate = new Date().getTime();
      const endDate = new Date(this.endDate).getTime();
      const selectedDate = new Date(val).getTime();

      if(selectedDate <= currentDate) {
        if(this.endDate && selectedDate < endDate) {
          return true;
        }
        return true;
      }

      return false;
    },
    allowedMinDate(val) {
      const currentDate = new Date().getTime();
      const startDate = new Date(this.startDate).getTime();
      const selectedDate = new Date(val).getTime();

      if(selectedDate <= currentDate && selectedDate > startDate) {
        return true;
      }

      return false;
    },
  },
  components: {
    AppWidget
  }
}
</script>